/**
 * Constants for TasksV2 module
 * Centralized constants to avoid magic strings and ensure consistency
 */

/**
 * Task Stage Names (lowercase as stored in backend)
 */
export const TASK_STAGES = {
  TO_DO: 'to_do',
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
};

/**
 * Task Status Values
 */
export const TASK_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

/**
 * Card Heights and Layout
 */
export const LAYOUT = {
  CARD_GAP: 8,
  LOADING_INDICATOR_HEIGHT: 80,
  ESTIMATED_CARD_HEIGHT: 280,
  DEFAULT_PAGE_LIMIT: 15,
  LOAD_MORE_PAGE_LIMIT: 20,
  INFINITE_SCROLL_THRESHOLD: 5, // Items from bottom to trigger load more
};

/**
 * Cache and Query Configuration
 */
export const CACHE_CONFIG = {
  STALE_TIME: 2 * 60 * 1000, // 2 minutes
  GC_TIME: 10 * 60 * 1000, // 10 minutes
  RETRY_COUNT: 2,
};

/**
 * Operation Delays (for UX and preventing race conditions)
 */
export const DELAYS = {
  ENTITY_UNLOCK: 500, // Delay before unlocking entity after operation
  MUTATION_ERROR_RESET: 5000, // Auto-reset mutation errors after 5s
  DEBOUNCE_SEARCH: 300, // Debounce search input
};
